import { Outlet, useNavigate } from "react-router-dom";
import { useEffect, useState, Suspense } from "react";
import { ThemeProvider } from "@mui/material/styles";

import { ErrorBoundary } from "../../Common/ErrorBoundary/errorBoundary";
import { Menu } from "./Menu/menu";
import { getUser } from "../../../Requests/CommonRequests/commonRequests";
import { redirectToLoginWithReturn } from "../../../Utils/Helpers/Fetch/advancedFetch";
import Cookies from "js-cookie";
import { SimpleLoader } from "../../Common/Loader/simpleLoader";
import { themeContent } from "../../../Themes/themes";

export function Layout(props) {
    const [isLoaded, setIsLoaded] = useState(false);
    let navigate = useNavigate();

    useEffect(() => {
        const redirectToLogin = redirectToLoginWithReturn;

        if (Cookies.get('token')) {
            getUser(props)
                .then((res) =>
                    {
                        if (res.payload?.message === 'Unauthenticated.') {
                            redirectToLogin();
                        } else {
                            setIsLoaded(true)
                        }
                    },
                    (error) => console.log(error)
                )
        } else {
            redirectToLogin();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <ThemeProvider theme={themeContent}>
            <div>
                <ErrorBoundary>
                    <Suspense fallback={<div></div>}>
                        {isLoaded && <Outlet context={{ ...props }} />}
                    </Suspense>
                </ErrorBoundary>

                <Menu {...props} />
            </div>
        </ThemeProvider>
    );
}